import React, { createContext, PropsWithChildren, useContext } from "react"

import { IHttpService } from "./types"

export interface HttpServiceContextValue {
  http: IHttpService
}

export const HttpServiceProvider = ({ children, service }: HttpServiceProviderProps) =>
  <Context.Provider value={{ http: service }} {...{ children }} />

type HttpServiceProviderProps = PropsWithChildren & { service: IHttpService }

const Context = createContext<HttpServiceContextValue | null>(null)

export function useHttp() {
  const context = useContext(Context)

  if (!context) throw new Error("useHttp must be used within a HttpServiceProvider")
  return context
}
